import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import DatePicker from "react-datepicker";
import { Button, Paper } from '@mui/material';
import "react-datepicker/dist/react-datepicker.css";
import Select from 'react-select';
import * as Yup from "yup";
import { useFormik } from 'formik';
import { FocusError } from 'focus-formik-error';
import { useDispatch, useSelector } from 'react-redux';
// import toast, { Toaster } from 'react-hot-toast';
import axios from 'axios';
import { BeatLoader } from 'react-spinners';
import { toast } from 'react-toastify';
import { adminMainUrl } from "../../../Config.jsx";
import { getCustomerProfileData } from '../../../Redux/action/Admin/CustomerAction.js';

const CompanyDetails = ({ loadingCustomerProfileDataApi, CustomerProfileDataError, CustomerProfileData, disbaledProfileEditing }) => {

  let [disable, setDisable] = useState(false);
  let [showLoader, setShowLoader] = useState(true);
  const [filePreview, setFilePreview] = useState([]);
  const [showIndiField, setShowIndiField] = useState(false);
  const token = Cookies.get('customertoken');

  const handleIndividual = (e) => {
    if (e.target.value == 'Individual/Proprietary firm') {
      setShowIndiField(true)
    }
    else {
      setShowIndiField(false)
    }
  }
  const dispatch = useDispatch();






  let initialValues = {
    licenseImage: [],
    customerType: "",
    name: "",
    individualName: "",
    yearOfEstablishment: "",
    CIN: "",
    GST: "",
    TAN: "",
    PAN: "",
    nameOfAuthority: "",
    permanentRegaddress: "",
    principalBusinessAddress: "",
    typeOfBusiness: "",
    descriptionOfBusiness: "",
    websiteLink: "",
    directorProprietorName: "",
    directorProprietorNumber: "",
    directorProprietorEmail: "",
    salesPersonName: "",
    salesPersonNumber: "",
    salesPersonEmail: "",
    accountsPersonName: "",
    accountsPersonNumber: "",
    accountsPersonEmail: "",
    financeControllerName: "",
    financeControllerNumber: "",
    financeControllerEmail: "",
    msmeIndustryType: "",
    msmeRegNo: "",
    previourAgentAddress: "",
    reasonOfLeavingPreviousAgent: "",
    currentlyWorkingWith: "",
  }

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: Yup.object({
      customerType: Yup.string().required("Please select customer type."),
      name: Yup.string().required("Please enter name."),
      // name: showIndiField ? Yup.string() : Yup.string().required("Please enter name."),
      // individualName: showIndiField ? Yup.string().required("Please enter individual name.") : Yup.string(),
      // CIN: Yup.string().required("Please enter CIN No."),
      // GST: Yup.string().required('Please enter GST No.'),
      // TAN: Yup.string().required('Please enter TAN No.'),
      // PAN: Yup.string().required('Please enter PAN No.'),
      // nameOfAuthority: Yup.string().required("Please enter name of the Directors / Partners / Agents / Proprietor."),
      // permanentRegaddress: Yup.string().required("Please enter permanent or registered address."),
      // principalBusinessAddress: Yup.string().required('Please enter principal business address.'),
      // typeOfBusiness: Yup.string().required("Please select type of business."),
      // descriptionOfBusiness: Yup.string().required("Please give brief description of business of your entity."),
      // directorProprietorName: Yup.string().required("Please enter director/ proprietor name."),
      // directorProprietorNumber: Yup.string().required('Please enter director/ proprietor number.').matches(/^\d{10}$/, "Phone Number must contain exactly 10 digits"),
      // directorProprietorEmail: Yup.string().required('Please enter director/ proprietor email.').matches(/^\w+[-\.\w]*@(?!(?:)\.com$)\w+[-\.\w]*?\.\w{2,3}$/, "Enter a valid email"),
      // salesPersonName: Yup.string().required('Please enter sales person name.'),
      // salesPersonNumber: Yup.string().required("Please enter sales person number.").matches(/^\d{10}$/, "Phone Number must contain exactly 10 digits"),

      // salesPersonEmail: Yup.string().required("Please enter sales person email.").matches(/^\w+[-\.\w]*@(?!(?:)\.com$)\w+[-\.\w]*?\.\w{2,3}$/, "Enter a valid email"),
      // accountsPersonName: Yup.string().required("Please enter account person name."),
      // accountsPersonNumber: Yup.string().required("Please enter account person number.").matches(/^\d{10}$/, "Phone Number must contain exactly 10 digits"),
      // accountsPersonEmail: Yup.string().required('Please enter account person email.').matches(/^\w+[-\.\w]*@(?!(?:)\.com$)\w+[-\.\w]*?\.\w{2,3}$/, "Enter a valid email"),
      // financeControllerName: Yup.string().required('Please enter finance controller name.'),
      // financeControllerNumber: Yup.string().required('Please enter finance controller number.').matches(/^\d{10}$/, "Phone Number must contain exactly 10 digits"),
      // financeControllerEmail: Yup.string().required("Please enter finance controller email.").matches(/^\w+[-\.\w]*@(?!(?:)\.com$)\w+[-\.\w]*?\.\w{2,3}$/, "Enter a valid email"),
      // msmeIndustryType: Yup.string().required("Please select MSME industry type."),
      // msmeRegNo: Yup.string().required("Please enter MSME No."),


    }),
    onSubmit: (values, { resetForm }) => {
      setDisable(true);
      try {
        console.log(values);
        const formData = new FormData();
        formData.append("customerType", values.customerType);
        // if (showIndiField) {
        //   formData.append("individualName", values.individualName);
        //   formData.append("name", '');
        // }
        // else {
        //   formData.append("name", values.name);
        //   formData.append("individualName", '');
        // }
        formData.append("name", values.name);
        formData.append("yearOfEstablishment", values.yearOfEstablishment);
        formData.append("CIN", values.CIN);
        formData.append("GST", values.GST);
        formData.append("TAN", values.TAN);
        formData.append("PAN", values.PAN);
        formData.append("nameOfAuthority", values.nameOfAuthority);
        formData.append("permanentRegaddress", values.permanentRegaddress);
        formData.append("principalBusinessAddress", values.principalBusinessAddress);
        formData.append("typeOfBusiness", values.typeOfBusiness);
        formData.append("descriptionOfBusiness", values.descriptionOfBusiness);
        formData.append("websiteLink", values.websiteLink);
        formData.append("directorProprietorName", values.directorProprietorName);
        formData.append("directorProprietorNumber", values.directorProprietorNumber);
        formData.append("directorProprietorEmail", values.directorProprietorEmail);
        formData.append("salesPersonName", values.salesPersonName);
        formData.append("salesPersonNumber", values.salesPersonNumber);
        formData.append("salesPersonEmail", values.salesPersonEmail);
        formData.append("accountsPersonName", values.accountsPersonName);
        formData.append("accountsPersonNumber", values.accountsPersonNumber);
        formData.append("accountsPersonEmail", values.accountsPersonEmail);
        formData.append("financeControllerName", values.financeControllerName);
        formData.append("financeControllerNumber", values.financeControllerNumber);
        formData.append("financeControllerEmail", values.financeControllerEmail);
        formData.append("msmeIndustryType", values.msmeIndustryType);
        formData.append("msmeRegNo", values.msmeRegNo);
        formData.append("previourAgentAddress", values.previourAgentAddress);
        formData.append("reasonOfLeavingPreviousAgent", values.reasonOfLeavingPreviousAgent);
        formData.append("currentlyWorkingWith", values.currentlyWorkingWith);
        if (values.licenseImage && values.licenseImage.length > 0) {
          values.licenseImage.forEach((file) => {
            formData.append('licenseImage', file);  // 'licenseImage' is the field name the backend expects
          });
        }

        let config = { headers: { "auth-token": Cookies.get('customertoken'), 'content-type': 'multipart/form-data', } }


        axios.post(`${adminMainUrl}/api/customer-profile/company-update`, formData, config)
          .then(res => {
            if (res.status === 200) {

              resetForm();
              toast.success(res.data.msg);
              setDisable(false);
              dispatch(getCustomerProfileData(token))

            } else {
              toast.error(res.data.msg);
              setDisable(false);
            }
          }).catch(err => {
            console.log(err);
            if (err.response) {
              toast.error(err.response.data.msg);
            } else {
              toast.error("Internal server error.")
            }
            setDisable(false);
          });


      } catch (error) {
        console.log(error);
        toast.error(error.response.data.msg);
        setDisable(false);
      }
    }
  });


  useEffect(() => {
    if (CustomerProfileData) {
      formik.setValues({
        customerType: CustomerProfileData?.customerType ?? "",
        name: CustomerProfileData.name ?? "",
        individualName: CustomerProfileData.individualName ?? "",
        yearOfEstablishment: CustomerProfileData.yearOfEstablishment ?? "",
        CIN: CustomerProfileData.CIN ?? "",
        GST: CustomerProfileData.GST ?? "",
        TAN: CustomerProfileData.TAN ?? "",
        PAN: CustomerProfileData.PAN ?? "",
        nameOfAuthority: CustomerProfileData.nameOfAuthority ?? "",
        permanentRegaddress: CustomerProfileData.permanentRegaddress ?? "",
        principalBusinessAddress: CustomerProfileData.principalBusinessAddress ?? "",
        typeOfBusiness: CustomerProfileData.typeOfBusiness ?? "",
        descriptionOfBusiness: CustomerProfileData.descriptionOfBusiness ?? "",
        websiteLink: CustomerProfileData?.websiteLink ?? "",
        directorProprietorName: CustomerProfileData.directorProprietorName ?? "",
        directorProprietorNumber: CustomerProfileData.directorProprietorNumber ?? "",
        directorProprietorEmail: CustomerProfileData.directorProprietorEmail ?? "",
        salesPersonName: CustomerProfileData.salesPersonName ?? "",
        salesPersonNumber: CustomerProfileData.salesPersonNumber ?? "",
        salesPersonEmail: CustomerProfileData.salesPersonEmail ?? "",
        accountsPersonName: CustomerProfileData.accountsPersonName ?? "",
        accountsPersonNumber: CustomerProfileData.accountsPersonNumber ?? "",
        accountsPersonEmail: CustomerProfileData.accountsPersonEmail ?? "",
        financeControllerName: CustomerProfileData.financeControllerName ?? "",
        financeControllerNumber: CustomerProfileData.financeControllerNumber ?? "",
        financeControllerEmail: CustomerProfileData.financeControllerEmail ?? "",
        msmeIndustryType: CustomerProfileData.msmeIndustryType ?? "",
        msmeRegNo: CustomerProfileData.msmeRegNo ?? "",
        previourAgentAddress: CustomerProfileData.previourAgentAddress ?? "",
        reasonOfLeavingPreviousAgent: CustomerProfileData.reasonOfLeavingPreviousAgent ?? "",
        currentlyWorkingWith: CustomerProfileData.currentlyWorkingWith ?? "",
      })
      if (CustomerProfileData?.customerType == 'Individual/Proprietary firm') {
        setShowIndiField(true)
      }
      else {
        setShowIndiField(false)
      }
    }
  }, [CustomerProfileData])

  useEffect(() => {
    if (CustomerProfileData && CustomerProfileData?.CustomerLicenseCertificates?.length > 0) {
      const existingImages = CustomerProfileData?.CustomerLicenseCertificates?.map((certificate) => `${adminMainUrl}/${certificate.image}`);
      setFilePreview(existingImages); // Set existing images for preview
    }
  }, [CustomerProfileData]);

  // Handling new file uploads
  // const handleFileChange = (e) => {
  //   const files = Array.from(e.target.files); // Get selected files
  //   const newFilePreviews = files.map((file) => URL.createObjectURL(file)); // Create previews for new files

  //   // Update Formik values with new files only
  //   formik.setFieldValue('licenseImage', files);

  //   // Set new file previews, discarding previous ones
  //   setFilePreview(newFilePreviews);
  // };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files); // Get selected files

    // Validate if all files are images
    const isAllImages = files.every((file) => file.type.startsWith('image/'));

    if (!isAllImages) {
      toast.error("Please upload images only.");
      formik.setFieldValue('licenseImage', []); // Reset Formik field value
      setFilePreview([]); // Reset file previews
      return;
    }

    if (files.length > 10) {
      toast.error("Max 10 images can be uploaded.");
      return;
    }

    // Create previews for valid files
    const newFilePreviews = files.map((file) => URL.createObjectURL(file));

    // Update Formik values with new files only
    formik.setFieldValue('licenseImage', files);

    // Set new file previews, discarding previous ones
    setFilePreview(newFilePreviews);
  };

  return (
    <>
      {/* <Toaster /> */}
      {

        <div className="customer_main_detail_form section1" id="section1">

          <form onSubmit={formik.handleSubmit} className='p-4'>
            <div className='form-heading-bg'>
              <span>Company Details</span>

            </div>
            <FocusError formik={formik} />
            <div className="row">
              <div className="col-md-6">
                <div className="mb-3">
                  <label
                    htmlFor="basicpill-firstname-input"
                    className="form-label"
                  >
                    Customer Type<span className="text-danger">*</span>
                  </label>
                  <select
                    type="text"
                    className="form-select form-select-sm"
                    id="basicpill-firstname-input"
                    placeholder="Enter here"
                    name='customerType'
                    onChange={(e) => { handleIndividual(e); formik.handleChange(e) }}
                    onBlur={formik.handleBlur}
                    value={formik.values.customerType}
                    disabled={disbaledProfileEditing}
                  >
                    <option value="">Select Customer Type</option>

                    <option >
                      Individual/Proprietary firm
                    </option>
                    <option>
                      Private or Public Limited Company
                    </option>
                    <option>
                      Partnership firm
                    </option>
                  </select>
                  <div className="help-block with-errors">
                    {formik.touched.customerType && formik.errors.customerType ? (
                      <div className='text-danger small'>{formik.errors.customerType}</div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label
                    htmlFor="basicpill-firstname-input"
                    className="form-label"
                  >
                    {showIndiField ? "Name of Individual" : "Name of Private or Public Limited Company / Partnership firm"}<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    maxLength={100}
                    className="form-control form-control-sm"
                    id="basicpill-firstname-input"
                    placeholder="Enter here"
                    name='name'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.name}
                    disabled={disbaledProfileEditing}
                  />
                  <div className="help-block with-errors">
                    {formik.touched.name && formik.errors.name ? (
                      <div className='text-danger small'>{formik.errors.name}</div>
                    ) : null}
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="mb-3">
                  <label
                    htmlFor="basicpill-firstname-input"
                    className="form-label"
                  >
                    Year of establishment (DD/MM/YYYY)
                  </label>
                  <input
                    type="date"
                    className="form-control form-control-sm"
                    id="basicpill-firstname-input"
                    placeholder="Enter here"
                    name='yearOfEstablishment'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    min="1900-01-01"
                    value={formik.values.yearOfEstablishment}
                    disabled={disbaledProfileEditing}
                  />
                  <div className="help-block with-errors">
                    {formik.touched.yearOfEstablishment && formik.errors.yearOfEstablishment ? (
                      <div className='text-danger small'>{formik.errors.yearOfEstablishment}</div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label
                    htmlFor="basicpill-firstname-input"
                    className="form-label"
                  >
                    CIN No.
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="basicpill-firstname-input"
                    placeholder="Enter here"
                    name='CIN'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.CIN}
                    maxLength={35}
                    disabled={disbaledProfileEditing}
                    onInput={(e) => (e.target.value = e.target.value.replace(/\s/g, ''))}

                  />
                  <div className="help-block with-errors">
                    {formik.touched.CIN && formik.errors.CIN ? (
                      <div className='text-danger small'>{formik.errors.CIN}</div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label
                    htmlFor="basicpill-firstname-input"
                    className="form-label"
                  >
                    GST Regn. No.
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="basicpill-firstname-input"
                    placeholder="Enter here"
                    name='GST'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.GST}
                    maxLength={35}
                    disabled={disbaledProfileEditing}
                    onInput={(e) => (e.target.value = e.target.value.replace(/\s/g, ''))}


                  />
                  <div className="help-block with-errors">
                    {formik.touched.GST && formik.errors.GST ? (
                      <div className='text-danger small'>{formik.errors.GST}</div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label
                    htmlFor="basicpill-firstname-input"
                    className="form-label"
                  >
                    TAN No. (if not please mention N/A)
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="basicpill-firstname-input"
                    placeholder="Enter here"
                    name='TAN'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.TAN}
                    maxLength={35}
                    disabled={disbaledProfileEditing}
                    onInput={(e) => (e.target.value = e.target.value.replace(/\s/g, ''))}


                  />
                  <div className="help-block with-errors">
                    {formik.touched.TAN && formik.errors.TAN ? (
                      <div className='text-danger small'>{formik.errors.TAN}</div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label
                    htmlFor="basicpill-firstname-input"
                    className="form-label"
                  >
                    PAN No.
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="basicpill-firstname-input"
                    placeholder="Enter here"
                    name='PAN'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.PAN}
                    maxLength={35}
                    disabled={disbaledProfileEditing}
                    onInput={(e) => (e.target.value = e.target.value.replace(/\s/g, ''))}


                  />
                  <div className="help-block with-errors">
                    {formik.touched.PAN && formik.errors.PAN ? (
                      <div className='text-danger small'>{formik.errors.PAN}</div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label
                    htmlFor="basicpill-firstname-input"
                    className="form-label"
                  >
                    Name of the Directors / Partners
                    / Proprietor etc.
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="basicpill-firstname-input"
                    placeholder="Enter here"
                    name='nameOfAuthority'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.nameOfAuthority}
                    maxLength={100}
                    disabled={disbaledProfileEditing}

                  />
                  <div className="help-block with-errors">
                    {formik.touched.nameOfAuthority && formik.errors.nameOfAuthority ? (
                      <div className='text-danger small'>{formik.errors.nameOfAuthority}</div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label
                    htmlFor="basicpill-firstname-input"
                    className="form-label"
                  >
                    Permanent or Registered address
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="basicpill-firstname-input"
                    placeholder="Enter here"
                    name='permanentRegaddress'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.permanentRegaddress}
                    maxLength={200}
                    disabled={disbaledProfileEditing}

                  />
                  <div className="help-block with-errors">
                    {formik.touched.permanentRegaddress && formik.errors.permanentRegaddress ? (
                      <div className='text-danger small'>{formik.errors.permanentRegaddress}</div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label
                    htmlFor="basicpill-firstname-input"
                    className="form-label"
                  >
                    Principal Business address
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="basicpill-firstname-input"
                    placeholder="Enter here"
                    name='principalBusinessAddress'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.principalBusinessAddress}
                    maxLength={200}
                    disabled={disbaledProfileEditing}

                  />
                  <div className="help-block with-errors">
                    {formik.touched.principalBusinessAddress && formik.errors.principalBusinessAddress ? (
                      <div className='text-danger small'>{formik.errors.principalBusinessAddress}</div>
                    ) : null}
                  </div>
                </div>
              </div>

              <div className="col-md-12 row">
                <div className="mb-3">
                  <div className='col-md-12'>
                    <label
                      htmlFor="basicpill-firstname-input"
                      className="form-label"
                    >
                      Brief Description of Business of your
                      entity
                    </label>
                  </div>
                  <div className='col-md-12'>
                    <textarea
                      type="text"
                      className="form-control" aria-label="With textarea"
                      id="basicpill-firstname-input"
                      placeholder="Enter here"
                      name='descriptionOfBusiness'
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.descriptionOfBusiness}
                      cols={50}
                      maxLength={250}
                      disabled={disbaledProfileEditing}

                    ></textarea>
                  </div>
                  <div className="help-block with-errors">
                    {formik.touched.descriptionOfBusiness && formik.errors.descriptionOfBusiness ? (
                      <div className='text-danger small'>{formik.errors.descriptionOfBusiness}</div>
                    ) : null}
                  </div>
                </div>
              </div>

              <div className="col-lg-3">
                <div className="mb-3">
                  <label
                    htmlFor="basicpill-firstname-input"
                    className="form-label"
                  >
                    Director/ Proprietor
                  </label>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="mb-3">
                  <input
                    type="text"
                    maxLength={250}
                    className="form-control form-control-sm"
                    id="basicpill-firstname-input"
                    placeholder="Enter name here"
                    name='directorProprietorName'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.directorProprietorName}
                    disabled={disbaledProfileEditing}

                  />
                  <div className="help-block with-errors">
                    {formik.touched.directorProprietorName && formik.errors.directorProprietorName ? (
                      <div className='text-danger small'>{formik.errors.directorProprietorName}</div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="mb-3">
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="basicpill-firstname-input"
                    placeholder="Enter contact number here"
                    name='directorProprietorNumber'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.directorProprietorNumber}
                    maxLength={15}
                    onInput={(event) => {
                      let value = event.target.value;
                      value = value.replace(/[^0-9]/g, '');
                      event.target.value = value;
                    }}
                    disabled={disbaledProfileEditing}

                  />
                  <div className="help-block with-errors">
                    {formik.touched.directorProprietorNumber && formik.errors.directorProprietorNumber ? (
                      <div className='text-danger small'>{formik.errors.directorProprietorNumber}</div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="mb-3">
                  <input
                    type="email"
                    maxLength={100}
                    className="form-control form-control-sm"
                    id="basicpill-firstname-input"
                    placeholder="Enter email here"
                    name='directorProprietorEmail'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.directorProprietorEmail}
                    disabled={disbaledProfileEditing}

                  />
                  <div className="help-block with-errors">
                    {formik.touched.directorProprietorEmail && formik.errors.directorProprietorEmail ? (
                      <div className='text-danger small'>{formik.errors.directorProprietorEmail}</div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="mb-3">
                  <label
                    htmlFor="basicpill-firstname-input"
                    className="form-label"
                  >
                    Sales
                  </label>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="mb-3">
                  <input
                    type="text"
                    maxLength={250}
                    className="form-control form-control-sm"
                    id="basicpill-firstname-input"
                    placeholder="Enter name here"
                    name='salesPersonName'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.salesPersonName}
                    disabled={disbaledProfileEditing}

                  />
                  <div className="help-block with-errors">
                    {formik.touched.salesPersonName && formik.errors.salesPersonName ? (
                      <div className='text-danger small'>{formik.errors.salesPersonName}</div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="mb-3">
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="basicpill-firstname-input"
                    placeholder="Enter contact number here"
                    name='salesPersonNumber'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.salesPersonNumber}
                    maxLength={15}
                    onInput={(event) => {
                      let value = event.target.value;
                      value = value.replace(/[^0-9]/g, '');
                      event.target.value = value;
                    }}
                    disabled={disbaledProfileEditing}

                  />
                  <div className="help-block with-errors">
                    {formik.touched.salesPersonNumber && formik.errors.salesPersonNumber ? (
                      <div className='text-danger small'>{formik.errors.salesPersonNumber}</div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="mb-3">
                  <input
                    type="email"
                    maxLength={100}
                    className="form-control form-control-sm"
                    id="basicpill-firstname-input"
                    placeholder="Enter email here"
                    name='salesPersonEmail'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.salesPersonEmail}
                    disabled={disbaledProfileEditing}

                  />
                  <div className="help-block with-errors">
                    {formik.touched.salesPersonEmail && formik.errors.salesPersonEmail ? (
                      <div className='text-danger small'>{formik.errors.salesPersonEmail}</div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="mb-3">
                  <label
                    htmlFor="basicpill-firstname-input"
                    className="form-label"
                  >
                    Accounts
                  </label>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="mb-3">
                  <input
                    type="text"
                    maxLength={250}
                    className="form-control form-control-sm"
                    id="basicpill-firstname-input"
                    placeholder="Enter name here"
                    name='accountsPersonName'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.accountsPersonName}
                    disabled={disbaledProfileEditing}

                  />
                  <div className="help-block with-errors">
                    {formik.touched.accountsPersonName && formik.errors.accountsPersonName ? (
                      <div className='text-danger small'>{formik.errors.accountsPersonName}</div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="mb-3">
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="basicpill-firstname-input"
                    placeholder="Enter contact number here"
                    name='accountsPersonNumber'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.accountsPersonNumber}
                    maxLength={15}
                    onInput={(event) => {
                      let value = event.target.value;
                      value = value.replace(/[^0-9]/g, '');
                      event.target.value = value;
                    }}
                    disabled={disbaledProfileEditing}

                  />
                  <div className="help-block with-errors">
                    {formik.touched.accountsPersonNumber && formik.errors.accountsPersonNumber ? (
                      <div className='text-danger small'>{formik.errors.accountsPersonNumber}</div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="mb-3">
                  <input
                    type="email"
                    maxLength={100}
                    className="form-control form-control-sm"
                    id="basicpill-firstname-input"
                    placeholder="Enter email here"
                    name='accountsPersonEmail'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.accountsPersonEmail}
                    disabled={disbaledProfileEditing}

                  />
                  <div className="help-block with-errors">
                    {formik.touched.accountsPersonEmail && formik.errors.accountsPersonEmail ? (
                      <div className='text-danger small'>{formik.errors.accountsPersonEmail}</div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="mb-3">
                  <label
                    htmlFor="basicpill-firstname-input"
                    className="form-label"
                  >
                    Finance Controller
                  </label>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="mb-3">
                  <input
                    type="text"
                    maxLength={250}
                    className="form-control form-control-sm"
                    id="basicpill-firstname-input"
                    placeholder="Enter name here"
                    name='financeControllerName'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.financeControllerName}
                    disabled={disbaledProfileEditing}

                  />
                  <div className="help-block with-errors">
                    {formik.touched.financeControllerName && formik.errors.financeControllerName ? (
                      <div className='text-danger small'>{formik.errors.financeControllerName}</div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="mb-3">
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="basicpill-firstname-input"
                    placeholder="Enter contact number here"
                    name='financeControllerNumber'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.financeControllerNumber}
                    maxLength={15}
                    onInput={(event) => {
                      let value = event.target.value;
                      value = value.replace(/[^0-9]/g, '');
                      event.target.value = value;
                    }}
                    disabled={disbaledProfileEditing}

                  />
                  <div className="help-block with-errors">
                    {formik.touched.financeControllerNumber && formik.errors.financeControllerNumber ? (
                      <div className='text-danger small'>{formik.errors.financeControllerNumber}</div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="mb-3">
                  <input
                    type="email"
                    maxLength={100}
                    className="form-control form-control-sm"
                    id="basicpill-firstname-input"
                    placeholder="Enter email here"
                    name='financeControllerEmail'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.financeControllerEmail}
                    disabled={disbaledProfileEditing}

                  />
                  <div className="help-block with-errors">
                    {formik.touched.financeControllerEmail && formik.errors.financeControllerEmail ? (
                      <div className='text-danger small'>{formik.errors.financeControllerEmail}</div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="mb-3">
                  <label
                    htmlFor="basicpill-firstname-input"
                    className="form-label"
                  >
                    MSME Industry Type
                  </label>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="mb-3">
                  <select
                    className="form-select form-select-sm mb-3"
                    aria-label=".form-select-lg example"
                    name='msmeIndustryType'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.msmeIndustryType}
                    disabled={disbaledProfileEditing}

                  >
                    <option value="">
                      Select Industry Type
                    </option>
                    <option >Micro</option>
                    <option>Small</option>
                    <option >Medium</option>
                  </select>
                  <div className="help-block with-errors">
                    {formik.touched.msmeIndustryType && formik.errors.msmeIndustryType ? (
                      <div className='text-danger small'>{formik.errors.msmeIndustryType}</div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="mb-3">
                  <input
                    type="text"
                    maxLength={50}
                    className="form-control form-control-sm"
                    id="basicpill-firstname-input"
                    placeholder="Enter registration number here"
                    name='msmeRegNo'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.msmeRegNo}
                    disabled={disbaledProfileEditing}

                  />
                  <div className="help-block with-errors">
                    {formik.touched.msmeRegNo && formik.errors.msmeRegNo ? (
                      <div className='text-danger small'>{formik.errors.msmeRegNo}</div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label
                    htmlFor="basicpill-firstname-input"
                    className="form-label"
                  >
                    Website of the business entity
                  </label>
                  <input
                    type="url"
                    className="form-control form-control-sm"
                    id="basicpill-firstname-input"
                    placeholder="Enter here"
                    name='websiteLink'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.websiteLink}
                    disabled={disbaledProfileEditing}
                    maxLength={250}

                  />
                  <div className="help-block with-errors">
                    {formik.touched.websiteLink && formik.errors.websiteLink ? (
                      <div className='text-danger small'>{formik.errors.websiteLink}</div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label
                    htmlFor="basicpill-firstname-input"
                    className="form-label"
                  >
                    Previous Agent’s Address
                  </label>
                  <input
                    type="text"
                    maxLength={250}
                    className="form-control form-control-sm"
                    id="basicpill-firstname-input"
                    placeholder="Enter here"
                    name='previourAgentAddress'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.previourAgentAddress}
                    disabled={disbaledProfileEditing}

                  />
                  <div className="help-block with-errors">
                    {formik.touched.previourAgentAddress && formik.errors.previourAgentAddress ? (
                      <div className='text-danger small'>{formik.errors.previourAgentAddress}</div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label
                    htmlFor="basicpill-firstname-input"
                    className="form-label"
                  >
                    Reason for leaving them
                  </label>
                  <input
                    type="text"
                    maxLength={250}
                    className="form-control form-control-sm"
                    id="basicpill-firstname-input"
                    placeholder="Enter here"
                    name='reasonOfLeavingPreviousAgent'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.reasonOfLeavingPreviousAgent}
                    disabled={disbaledProfileEditing}

                  />
                  <div className="help-block with-errors">
                    {formik.touched.reasonOfLeavingPreviousAgent && formik.errors.reasonOfLeavingPreviousAgent ? (
                      <div className='text-danger small'>{formik.errors.reasonOfLeavingPreviousAgent}</div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label
                    htmlFor="basicpill-firstname-input"
                    className="form-label"
                  >
                    Currently Working With
                  </label>
                  <input
                    type="text"
                    maxLength={250}
                    className="form-control form-control-sm"
                    id="basicpill-firstname-input"
                    placeholder="Enter here"
                    name='currentlyWorkingWith'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.currentlyWorkingWith}
                    disabled={disbaledProfileEditing}

                  />
                  <div className="help-block with-errors">
                    {formik.touched.currentlyWorkingWith && formik.errors.currentlyWorkingWith ? (
                      <div className='text-danger small'>{formik.errors.currentlyWorkingWith}</div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label htmlFor="basicpill-firstname-input" className="form-label">
                    Licenses and Certificates
                  </label>
                  {!disbaledProfileEditing && <div className="custom-file-container">

                    <label className="custom-file-container__custom-file">
                      <i className="fa-solid fa-upload"></i> Upload Files
                      <input
                        type="file"
                        className="custom-file-container__custom-file__custom-file-input d-none"
                        multiple
                        accept="image/*" // Ensure only image files are selected
                        onChange={(e) => {
                          handleFileChange(e);
                        }}
                        onBlur={formik.handleBlur}
                        disabled={disbaledProfileEditing}

                      />
                      <span className="custom-file-container__custom-file__custom-file-control"></span>
                    </label>
                  </div>}
                  <div className="help-block with-errors">
                    {formik.touched.licenseImage && formik.errors.licenseImage ? (
                      <div className="text-danger small">{formik.errors.licenseImage}</div>
                    ) : null}
                  </div>

                  {/* Image Preview Section */}
                  <div className="image-preview">
                    {filePreview.length > 0 && filePreview.map((imageUrl, index) => (
                      <img
                        key={index}
                        src={imageUrl}
                        alt={`License ${index}`}
                        className="img-thumbnail"
                        style={{ width: "100px", height: "100px", margin: "5px" }}
                      />
                    ))}
                  </div>
                </div>
              </div>

            </div>
            {!disbaledProfileEditing && <Paper className='h-100 d-flex flex-col justify-content-end w-100' square elevation={0} >

              <div className='button-container' style={{ marginTop: '20px' }}>

                <Button
                  className='btn-stepper  btn btn-primary'
                  variant="contained"
                  type='submit'
                  disabled={disable}

                >
                  {!disable ? "Update" : <i className="fas fa-spinner fa-spin" style={{ color: "#fff" }}></i>}
                </Button>
              </div>
            </Paper>}
          </form>
        </div>
      }

    </>

  )
}

export default CompanyDetails